import cn from 'classnames'
import { FC, useCallback } from 'react'

import { InfoBlock, InfoBlockType } from 'cng-common/components/infoBlock'
import { Translation } from 'cng-common/features/translations'
import { useAppDispatch } from 'cng-common/hooks/useAppDispatch'
import { Button } from 'core-components/library/button'

import { BUSINESS_PRIORITIES_TRANSLATION_KEYS as TRANSLATION_KEYS } from '../../configs/translations'
import { requestBusinessPrioritiesData } from '../../model'
import { requestBusinessPrioritiesPublish } from '../../model/thunks/requestBusinessPrioritiesPublish'

import styles from './BusinessPrioritiesBanner.module.scss'

interface IBusinessPrioritiesBannerWorldwideProps {
  isWorldwide: true
  canPublish: boolean
}

interface IBusinessPrioritiesBannerMarketProps {
  isWorldwide: false
  changesCount: number
  date: string
}

type TBusinessPrioritiesBannerProps =
  | IBusinessPrioritiesBannerWorldwideProps
  | IBusinessPrioritiesBannerMarketProps

export const BusinessPrioritiesBanner: FC<TBusinessPrioritiesBannerProps> = (props) => {
  const dispatch = useAppDispatch()

  const handlePublish = useCallback(async () => {
    await dispatch(requestBusinessPrioritiesPublish()).unwrap()
    await dispatch(requestBusinessPrioritiesData()).unwrap()
  }, [dispatch])

  if (props.isWorldwide) {
    if (!props.canPublish) {
      return null
    }

    return (
      <InfoBlock
        customIconClass={cn(styles.iconWrapper, 'kbase kbase-warning-alt')}
        type={InfoBlockType.Warning}
        text={
          <div className={styles.infoBlockContent}>
            <div className={styles.firstSentence}>
              <Translation text={TRANSLATION_KEYS.banner.notPublishedTitle} />
            </div>
            <Translation text={TRANSLATION_KEYS.banner.notPublishedMessage} />
            <Button variant="text" className={styles.publishButton} onClick={handlePublish}>
              <div className={styles.buttonContent}>
                <Translation text={TRANSLATION_KEYS.banner.publishAction} />
                <i className="kbase kbase-arrow-right" />
              </div>
            </Button>
          </div>
        }
      />
    )
  }

  return (
    <InfoBlock
      customIconClass={cn(styles.iconWrapper, 'kbase kbase-check-circle-alt')}
      type={InfoBlockType.Success}
      text={
        <div className={styles.infoBlockContent}>
          <div className={styles.firstSentence}>
            <Translation
              text={TRANSLATION_KEYS.banner.changesSinceLastVisit}
              replaceParams={[
                { key: '{changesCount}', value: props.changesCount.toString() },
                { key: '{date}', value: props.date },
              ]}
            />
          </div>
          ({props.date})
        </div>
      }
    />
  )
}
